import React, { Component } from 'react';
import cookie from 'react-cookies';
import { Link } from 'react-router-dom';
import axios from 'axios';
import {API_URL} from '../../../constants';
import { toast } from 'react-toastify';
import {hideNav, showLoader, hideLoader, configureMoment} from '../../../functions';
import Moment from 'moment';
import { getFrontPageUrl, bearerTknCache, cacheConfig as config } from '../../../utils/functions';
import { Button, Modal } from 'react-bootstrap';

export default class CachePanel extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            cacheObjects: 0,
            loading: true,
            showModal: false
        };
    }

    componentDidMount(){
        this.getCache();
    }

    getCache(){
        const baseUrl   = getFrontPageUrl();

        const urlGetCache = `${baseUrl}/cache/size`;
        axios.get(
            urlGetCache, 
            config
        ).then((res) => {
            console.log('CACHE DATA', res.data);
            this.setState({
                cacheObjects: res.data.size,
                loading: false
            });
        }).catch((err) => {
            console.error(err);
        });
    }

    clearCache(){
        const baseUrl   = getFrontPageUrl();
        const urlGetCache = `${baseUrl}/cache/clear`;
        axios.delete(
            urlGetCache, 
            config
        ).then((res) => {

            console.log('CACHE DATA', res.data);
            toast.success(res.data.message);
            this.getCache();
            this.setState({
                showModal: false
            });
            
        }).catch((err) => {
            console.error(err);
        });
    }

    handleClose(){
        this.setState({
            showModal: false
        });
    }

    render(){
        return (
            <div>
                <div className="divContenedorBreadcrumbs">
                    <div className="divCenterBreadcrumbs">
                        <img src="/static/images/icoBreadcrumb.png" alt="icon-breadcrumb" />
                        <a href="/">
                            / Panel de Configuración General
                        </a>
                        <span> / Cache</span>
                    </div>
                </div>
                <div className="divTitulo_Panel">
                    Caché
                </div>
                {this.state.loading ?
                    <div className="divSector_Panel">
                        <div className="loader-data">
                        </div>
                    </div>
                :
                    <div className="divSector_Panel">
                        <p className='h6 mb-3'>
                            Se encontraron {this.state.cacheObjects} objetos almacenados en caché.
                        </p>
                        {this.state.cacheObjects > 0 &&
                            <button className='btn btn-danger' onClick={() => {
                                this.setState({
                                    showModal: true
                                });
                            }}>
                                Borrar caché
                            </button>
                        }

                        <Modal show={this.state.showModal} onHide={() => this.handleClose()}>
                            <Modal.Header closeButton>
                                <Modal.Title>
                                    Borrar caché
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                ¿Desea eliminar {this.state.cacheObjects} objetos de la caché?
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={() => this.handleClose()}>
                                    No, Cancelar
                                </Button>
                                <Button variant="danger" onClick={() => this.clearCache()}>
                                    Si, Borrar
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                }
            </div>
        );
    }
}